/**
 * IdentityIntake — the shipped `ModelIntake`, mounted as the wall's overlay (operator, 2026-09-22:
 * "the simplest version wins"). Desktop: a centred panel over a scrim. Phone: the panel rises
 * full-height on its own, not through `Sheet.tsx`'s drag machinery. No celebration, no toast, no
 * route change: closing returns to the same armed tile.
 *
 * The pack page mounts it too (plan 2026_09_25_narcis_pack_coda.md): the whole pack trains from
 * its own page, and the sign-in asked at Start returns there.
 */
import {useRouteLoaderData} from 'react-router'
import {routerPaths} from '@routes'
import {useModelIntake} from '@core/hooks/useModelIntake'
import {ModelIntake} from '@product/narcis/components/ModelIntake/ModelIntake'
import {narcisIntakeEvent} from '@product/narcis/components/ModelIntake/narcisIntakeEvent'
import {compressImage} from '@product/narcis/utils/imageProcessing'
import type {loader as rootLoader} from '@root'
import styles from './IdentityIntake.module.scss'

export function IdentityIntake({onClose, signedIn, signupRedirectTo}: {
  onClose: (result?: {queued: true}) => void
  signedIn: boolean
  /** The address that reopens this intake — where the sign-in and the payment asked at Start return. */
  signupRedirectTo: string
}) {
  const rootData = useRouteLoaderData<typeof rootLoader>('root')
  const funnel = rootData?.funnel

  // A fresh bench per overlay open — this component unmounts with the overlay.
  const intake = useModelIntake({
    onEvent: narcisIntakeEvent,
    compress: compressImage,
    sessionPhotosUrl: '/api/model/session-photos',
  })

  if (!funnel) return null

  return (
    <div className={styles.arena}>
      <div className={styles.scrim} onClick={() => onClose()} />
      <div className={styles.panel} role="document">
        <button type="button" className={styles.close} onClick={() => onClose()} aria-label="Close">
          ✕
        </button>
        <ModelIntake
          intake={intake}
          isAuthenticated={signedIn}
          funnel={funnel}
          authAction={routerPaths['/auth/:provider']({provider: 'google'})}
          onDone={() => onClose({queued: true})}
          signupRedirectTo={signupRedirectTo}
        />
      </div>
    </div>
  )
}
